/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useContext } from 'react';

import { TextMessageContext } from '../contexts/TextMessageContext';

export const useTextMessage = () => useContext(TextMessageContext);
